import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { NoticesProvider } from '../../providers/notices/notices';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-notice-details',
  templateUrl: 'notice-details.html',
})
export class NoticeDetailsPage {

  notice: any;
  title: any;
  videoUrls: any;

  constructor(public navCtrl: NavController,
    private noticeProvider: NoticesProvider, 
    public navParams: NavParams,
    private translate: TranslateService,
    private util: UtilService) {
  	//console.log(this.navParams.data);
    this.notice = this.navParams.get("notice");
    this.title = this.navParams.get("title");

    if(this.notice.video_urls){
      this.videoUrls = JSON.parse(this.notice.video_urls);
    }

    if(this.notice.set_read){
      this.noticeProvider.markRead(this.notice.id).then(val => {
        console.log(val);
      });
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NoticeDetailsPage');
  }

  openUrl(url:string){
    this.util.openWithInAppBrowser(url);
  }

  getObject(s : string){
  	return JSON.parse(s);
  }

}



// WEBPACK FOOTER //
// ./src/pages/notice-details/notice-details.ts